import React from 'react';
import { Download } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DocumentsPanel({ hub, bookingId }) {
  const bid = bookingId || hub?.keys?.canonical_id;
  return (
    <div className="bg-white border border-gray-200 rounded-xl p-4 space-y-2" data-testid="documents-panel">
      <p className="text-[10px] uppercase font-bold text-gray-500">Documents</p>
      {bid && (
        <a
          href={`${API}/bookings/download-eticket/${encodeURIComponent(bid)}`}
          className="inline-flex items-center gap-2 text-sm text-[#1B375B] font-semibold hover:underline"
          data-testid="hub-download-eticket"
        >
          <Download className="w-4 h-4" /> E-Ticket PDF
        </a>
      )}
      <p className="text-xs text-gray-500">GST invoices and credit notes: use Support ticket actions.</p>
    </div>
  );
}
